import { render, staticRenderFns } from "./WorkbenchPreview.vue?vue&type=template&id=c6fc6e42&scoped=true&"
import script from "./WorkbenchPreview.vue?vue&type=script&lang=js&"
export * from "./WorkbenchPreview.vue?vue&type=script&lang=js&"
import style0 from "./WorkbenchPreview.vue?vue&type=style&index=0&id=c6fc6e42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6fc6e42",
  null
  
)

export default component.exports